module.exports = __webpack_public_path__ + "static/Google-Sheets-Import-aa08a43898e41e6a95807945e0fa8203.svg";